import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCat, faDog, faTurtle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PetTypeIds } from '@spike/model';
import { type Pet as PetModel } from '@spike/pet-model';
import styles from 'components/UI/V3/PetTag/PetTag.module.scss';
import { PetTypeIcon } from 'components/UI/V3/PetTypeIcon/PetTypeIcon';
import React from 'react';

type PetProp = Omit<Partial<PetModel>, 'name' | 'type'> & {
    name: PetModel['name'];
    type?: PetModel['type'];
};

interface PetTagProps {
    pet: PetProp;
    active?: boolean;
    onClick?: () => void;
}

const BACKGROUND_COLOR_MAP: Record<PetTypeIds, string> = {
    [PetTypeIds.DOGS]: 'var(--color-dogs-background)',
    [PetTypeIds.CATS]: 'var(--color-cats-background)',
    [PetTypeIds.EXOTICS]: 'var(--color-exotics-background)'
};

export const PetTag: React.FC<PetTagProps> = ({ pet, active = false, onClick }) => {
    const petTypeId = pet.type?.id as PetTypeIds;

    return (
        <div
            data-active={active}
            data-clickable={!!onClick}
            className={styles.root}
            onClick={onClick}
            style={
                {
                    '--background-color': BACKGROUND_COLOR_MAP[petTypeId]
                } as React.CSSProperties
            }
        >
            {pet.type && (
                <PetTypeIcon
                    size={24}
                    type={pet.type}
                    className={styles.icon}
                />
            )}

            <span className={styles.label}>{pet.name}</span>
        </div>
    );
};
